import { render, staticRenderFns } from "./VolunteerSummaryStandard.vue?vue&type=template&id=23c1ce86"
import script from "./VolunteerSummaryStandard.vue?vue&type=script&lang=ts"
export * from "./VolunteerSummaryStandard.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerSummaryStandard.vue?vue&type=style&index=0&id=23c1ce86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports